import Spinner from "react-bootstrap/Spinner";

function Loading() {
  return (
    <div data-testid="loading-container">
      <Spinner animation="border" variant="info" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </div>
  );
}

export default Loading;
